import { CreatePaymentsEmployerDto, IdentificationType } from '@zorro/clients';
import { dollarsToCents, tryFormatDateISO } from '@zorro/shared/formatters';
import { YesNo } from '@zorro/types';

import { CompanyDetailsFormFields } from '../../CompanyDetailsForm';

export const buildCreatePaymentsEmployerDto = (
  employerId: string,
  companyDetailsFields: CompanyDetailsFormFields,
  reserveAmount: number,
  thresholdAmount: number
): CreatePaymentsEmployerDto => {
  const primaryBeneficialOwner = companyDetailsFields.beneficialOwners?.[0];
  return {
    id: employerId,
    legalName: companyDetailsFields.isLegalNameSameAsCompanyName
      ? companyDetailsFields.name
      : companyDetailsFields.legalName!,
    businessEntityType: companyDetailsFields.businessEntityType!,
    ein: companyDetailsFields.taxId ?? '',
    incorporatedStateCode: companyDetailsFields.stateOfIncorporation!,
    businessYears: companyDetailsFields.yearsInBusiness ?? 0,
    websiteUrl: companyDetailsFields.websiteUrl,
    address: companyDetailsFields.address ?? '',
    email: primaryBeneficialOwner?.email ?? '',
    phone: primaryBeneficialOwner?.phone ?? '',
    isICHRAOnly: true,
    beneficialOwners: (companyDetailsFields.beneficialOwners ?? []).map(
      (beneficialOwner, index) => ({
        firstName: beneficialOwner.firstName ?? '',
        lastName: beneficialOwner.lastName ?? '',
        dateOfBirth: tryFormatDateISO(beneficialOwner.dateOfBirth) ?? '',
        isOfficer: companyDetailsFields.hasBeneficialOwners === YesNo.NO,
        identificationType: IdentificationType.SSN,
        identificationNumber: beneficialOwner.ssn ?? '',
        isPrimary: index === 0,
        address: beneficialOwner.address ?? '',
        phone: beneficialOwner.phone ?? '',
        email: beneficialOwner.email ?? '',
      })
    ),
    reserveAmountInCents: dollarsToCents(reserveAmount),
    thresholdAmountInCents: dollarsToCents(thresholdAmount),
  };
};
